<template>
    <div>
        <ul class="assess-list" >
            <router-link :to="{ name:'Assess-student-msg'}" tag="li" >留言<i class="iconfont icon-more" ></i></router-link>
            <router-link :to="{ name:'Assess-student-appeal'}" tag="li" >申诉<i class="iconfont icon-more" ></i></router-link>
        </ul>
        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
    </div>
</template>
<script>
import Bottom from '../bottom.vue'
export default {
    components: { Bottom }
}
</script>


// WEBPACK FOOTER //
// src/components/assessment/assess-student-appeal-entry.vue